// @ts-strict-ignore
import * as React from 'react';
import produce from 'immer';
import cloneDeep from 'lodash/cloneDeep';
import { hasCohortsOverTimeMetric } from 'common/report/insights/models/utils';
import { hasValidBookmarkParams } from '../validation';
import { ApplyParamsDetail, ReportBookmarkManagerBookmark, ReportState } from './types';
import { ReportBookmarkManager, ReportBookmarkManagerContext } from './index';

/**
 * Context provider for the ReportBookmark Panel context.
 *
 * This prevents leaking Panel context details for React components
 */
export function ReportBookmarkManagerProvider(props: {
  children: React.ReactNode;
  value: ReportBookmarkManager;
}) {
  const report: ReportState = {
    get type() {
      return props.value.bookmark?.type;
    },
    get params() {
      return props.value.bookmark?.params;
    },
    get name() {
      return props.value.bookmark?.name;
    },
    get description() {
      return props.value.bookmark?.description;
    },
    updateParams: (fn, options: ApplyParamsDetail = {}) => {
      let updatedBookmark: ReportBookmarkManagerBookmark = cloneDeep(props.value.bookmark);
      if (typeof fn === `function`) {
        updatedBookmark = produce(updatedBookmark, draft => {
          fn(draft.params);
        });
      } else {
        updatedBookmark.params = fn;
      }
      props.value.applyParams(updatedBookmark.params, options);
    },
    isValid(): boolean {
      if (!props.value.bookmark) {
        return false;
      }
      return `sections` in props.value.bookmark.params && hasValidBookmarkParams(props.value.bookmark.params);
    },
    hasCohortMetrics(): boolean {
      if (!props.value.bookmark) {
        return false;
      }
      return `sections` in props.value.bookmark.params && hasCohortsOverTimeMetric(props.value.bookmark.params);
    }
  };
  return <ReportBookmarkManagerContext.Provider value={report} data-sentry-element="unknown" data-sentry-component="ReportBookmarkManagerProvider" data-sentry-source-file="provider.tsx">{props.children}</ReportBookmarkManagerContext.Provider>;
}